/**
 * HTTP layer for relay-load scheduling contracts and calendar labels. The
 * recurring load schedules a site runs and the labels that annotate its
 * calendar.
 *
 * Contains:
 * - postRelayLoadContract / patchRelayLoadContract / deleteRelayLoadContract: contract writes
 * - postCalendarLabel / patchCalendarLabel / deleteCalendarLabel: calendar-label writes
 */
import apiClient from '@sophocles/http-common';

export const CONTRACTS_ENDPOINT = '/relayloadcontracts';

export const postRelayLoadContract = values =>
  apiClient.post(`${CONTRACTS_ENDPOINT}/`, values).then(response => {
    return response.data;
  });

export const patchRelayLoadContract = (id, values) =>
  apiClient.patch(`${CONTRACTS_ENDPOINT}/${id}/?ignore_conflicts=true`, values).then(response => {
    return response.data;
  });

export const deleteRelayLoadContract = id => apiClient.delete(`${CONTRACTS_ENDPOINT}/${id}/`).then(() => id);

// export const postCalendarLabel = values =>
// apiClient.post(`/calendarschedules/labels/`, values).then(response => {
//     return response.data;
// });

// export const patchCalendarLabel = (labelId, values) =>
// apiClient.patch(`/calendarschedules/labels/${labelId}/`, values).then(response => {
//     return response.data;
// });

// export const deleteCalendarLabel = labelId =>
// apiClient.delete(`/calendarschedules/labels/${labelId}/`).then(() => {
//     return labelId;
// });

// export function fetchAllRelayLoadContractsForRelayLoad(relayLoad) {
//     return dispatch => {
//       dispatch(requestRelayLoadContract(relayLoad));
//       return apiClient
//         .get(`/relayloadcontracts/?relay_load=${relayLoad}`)
//         .then(checkHttpStatus)
//         .then(response => fromJS(response.data))
//         .catch(error => dispatch(genericErrorAction(error, RECEIVE_RELAY_LOAD_CONTRACTS)));
//     };
//   }
